import React, { Component, useEffect, useState } from 'react'
import './App.css'
import { Link, Redirect, useHistory } from 'react-router-dom'
import Axios from 'axios'
import ReactTooltip from 'react-tooltip'
import QrReader from 'react-qr-scanner'
import Footer from './components/Footer'
import { API_URL } from './config'
import {
  IoIosContact,
  IoIosCalendar,
  IoIosBarcode,
  IoIosCard,
  IoMdHeartEmpty,
  IoMdPerson,
  IoIosLock,
  IoIosPaper,
  IoIosInformationCircleOutline,
  IoIosLogOut,
  IoIosRemoveCircleOutline,
  IoIosCheckmarkCircleOutline,
  IoIosPodium,
  IoMdPeople,
  IoIosPeople,
  IoIosAdd,
  IoIosAddCircleOutline,
  IoIosRefresh,
  IoIosArrowDown,
  IoIosArrowUp,
  IoMdPhonePortrait,
  IoLogoAndroid,
  IoLogoWindows,
  IoLogoChrome,
  IoLogoApple,
  IoIosBrowsers,
  IoIosSettings,
  IoIosCheckbox,
  IoIosCheckboxOutline,
  IoMdCheckbox,
  IoIosArrowBack,
} from 'react-icons/io'
import {
  BsCalendar,
  BsPeople,
  BsBoundingBoxCircles,
  BsPerson,
  BsLock,
  BsPen,
  BsApp,
  BsAppIndicator,
  BsArrowRight,
  BsGraphUp,
  BsSearch,
} from 'react-icons/bs'
import { BiCheckbox, BiDevices, BiEditAlt, BiMenu } from 'react-icons/bi'
import { AiOutlineScan } from 'react-icons/ai'
import {
  RiCalendarEventLine,
  RiCheckboxBlankFill,
  RiCheckboxBlankLine,
  RiCheckboxLine,
  RiMacbookLine,
} from 'react-icons/ri'
import { FaEdge, FaSafari, FaFirefox, FaLinux } from 'react-icons/fa'

// import Header from "./components/HeaderCampaign";
import Switch from 'react-switch'
// import HorizontalScroller from "react-horizontal-scroll-container";
import TopBarProgress from 'react-topbar-progress-indicator'
import Header3 from './components/Header3'
import {
  IoBrowsers,
  IoBrowsersSharp,
  IoCheckbox,
  IoCheckboxOutline,
  IoCheckboxSharp,
  IoPhonePortrait,
} from 'react-icons/io5'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'

const Campaignmanager = (Props) => {
  const history = useHistory()
  const [query, setQuery] = useState('')
  const isMobile = window.innerWidth <= 768
  const [password, setPassword] = useState('')
  const [response, setResponse] = useState('')
  const [error, setError] = useState('')
  const [errorDisplay, setErrorDisplay] = useState('none')
  const [details, setDetails] = useState([])
  const [events, setEvents] = useState([])
  const [queryResults, setQueryResults] = useState([])
  const [customerlist, setCustomerlist] = useState([])
  const [platformlist, setPlatformlist] = useState([])
  const [numberOfclientes, setNumberOfclientes] = useState(0)
  const [numberOfbooster, setNumberOfbooster] = useState(0)
  const [numberOfboosterDeactivated, setNumberOfboosterDeactivated] = useState(0)
  const [delay, setDelay] = useState(100)
  const [result, setResult] = useState('No result')
  const [loadBarProgress, setLoadBarProgress] = useState(true)
  const [refreshingText, setRefreshingText] = useState(false)
  const [loadingEvents, setLoadingEvents] = useState(false)
  const [loadCustomers, setLoadCustomers] = useState(false)
  const [loadingPlatforms, setLoadingPlatforms] = useState(false)
  const [newcampaignbutton, setNewcampaignbutton] = useState('new-campaign-button')
  const [customers, setCustomers] = useState('new-campaign-button')
  const [platforms, setPlatforms] = useState('new-campaign-button')
  const [tick, setTick] = useState(0)
  const [count, setCount] = useState(0)
  const [countU, setCountU] = useState(0)
  const [loadIndi, setLoadIndi] = useState(false)
  const [loadIndiBlank, setLoadIndiBlank] = useState(true)
  const [allselected, setAllselected] = useState(0)
  const [campaignCount, setCampaignCount] = useState(0)
  const [loadSearchBox, setLoadSearchBox] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [loadSearchresults, setLoadSearchresults] = useState(false)
  const [enddate, setEnddate] = useState('')
  const [eventdate, setEventdate] = useState('')
  const [eventid, setEventid] = useState('')
  const [eventname, setEventname] = useState('')
  const [poster, setPoster] = useState('')
  const [event_date, setEvent_date] = useState('')
  const [finish_date, setFinish_date] = useState('')
  const [theme, setTheme] = useState('')
  const [venue, setVenue] = useState('')
  const [expectednum, setExpectednum] = useState('')
  const [time, setTime] = useState('')
  const [endtime, setEndtime] = useState('')
  const [open, setOpen] = useState(false)
  const [campaignid, setCampaignid] = useState('')
  const [openLogo, setOpenLogo] = useState(false)
  const [arrowIcon, setArrowIcon] = useState(false)
  const [campaignname, setCampaignname] = useState('')
  const [balance, setBalance] = useState(0)
  const [alertType, setAlertType] = useState('error-login')
  const [isMob, setIsMob] = useState()
  const [collapsed, setCollapsed] = useState(isMobile)

  useEffect(() => {
    const businessname = localStorage.getItem('businessname')
    const accounttype = localStorage.getItem('accounttype')
    const businessid = localStorage.getItem('businessid')
    document.title = 'Campaigns | ' + businessname

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=UPDATEALLTRANSFER&campaignid=&businessid=${businessid}`,
      { withCredentials: true }
    ).catch((error) => console.log(error))

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=CAMPAIGNSTATSUSS&businessid=${businessid}`
    ).then((response) => {
      if (response.data.val === 1) {
        setCampaignCount(<label className="campaigncounts">{response.data.campaignCount}</label>)
      } else {
        setCampaignCount('')
      }
    })

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=CAMPAIGNS&businessid=${businessid}`, {
      withCredentials: true,
    })
      .then((response) => {
        setRefreshingText(false)
        if (response.data.status === 'failed') {
          setDetails([])
        } else {
          setDetails(response.data)
        }
        setLoadBarProgress(false)
      })
      .catch((error) => console.log(error))

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=MYEVENTS&accountid=${businessid}&accounttype=${accounttype}&thumbnail=yes`,
      { withCredentials: true }
    )
      .then((response) => {
        setEvents(response.data.val === 0 ? [] : response.data)
      })
      .catch((error) => console.log(error))

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=GETSELECTCAMPAIGNS&businessid=${businessid}`,
      { withCredentials: true }
    )
      .then((response) => {
        if (response.data.val === 0) {
          setCount(0)
        } else {
          setCount(response.data.selectedCount)
          setEventid(response.data.eventid)
          setEventname(response.data.eventname)
          setCampaignname(response.data.campaignname)
          setPoster(response.data.poster)
          setEventdate(response.data.eventday)
          setEnddate(response.data.enddate)
          setEvent_date(response.data.event_day)
          setFinish_date(response.data.finish_day)
          setTheme(response.data.theme)
          setVenue(response.data.venue)
          setExpectednum(response.data.expectednum)
          setTime(response.data.time)
          setEndtime(response.data.endtime)
        }
      })
      .catch((error) => console.log(error))

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=ALLSELECTCAMPAIGNS&businessid=${businessid}`,
      { withCredentials: true }
    )
      .then((response) => {
        setAllselected(response.data.val === 0 ? 0 : 1)
      })
      .catch((error) => console.log(error))

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)

    return () => {
      // this runs on unmount
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [countU])

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  const platformlistF = () => {
    let activeString = ''
    const accountid = localStorage.getItem('businessid')
    const businessname = localStorage.getItem('businessname')
    const accounttype = localStorage.getItem('accounttype')

    return (
      <div>
        {platformlist.length < 1 ? (
          <div>
            <label
              style={{
                width: '100%',
                textAlign: 'center',
                fontSize: 13.5,
                color: '#5B7083',
              }}
            >
              Devices not available, meaning the event under this campaign has not been accessed{' '}
            </label>
          </div>
        ) : (
          <div>
            <div className={'col-lg-12 p-0'}>
              <div className="w-100 pr-0 pl-0 pb-3 pt-3">
                <div className="w-100">
                  <div className="row" style={{ display: 'flex' }}>
                    <div className="col-6" style={{ cursor: 'pointer' }}>
                      <span>
                        <BiDevices size={20} />
                        &nbsp;Devices/OS
                      </span>
                    </div>

                    <div className="col-6" style={{ cursor: 'pointer' }}>
                      <span>
                        <IoBrowsersSharp size={20} /> &nbsp;Browsers
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={'col-lg-12 p-0'}>
              {platformlist.map((item, index) => {
                return (
                  <div className="w-100 pt-1 pb-0">
                    <div className="w-100">
                      <div className="row" style={{ display: 'flex' }}>
                        <div className="col-6" style={{ cursor: 'pointer' }}>
                          <label
                            className="item-names w-100 small-details p-0"
                            style={{
                              color: '#000',
                              cursor: 'pointer',
                              marginBottom: 0,
                            }}
                          >
                            <label style={{ fontWeight: 400, marginBottom: 0 }}>
                              {item.device == 'Android' ? (
                                <IoLogoAndroid size={20} color={'#66b266'} />
                              ) : item.device == 'Windows' ? (
                                <IoLogoWindows size={20} color={'#069'} />
                              ) : item.device == 'iPhone' ? (
                                <IoPhonePortrait size={20} color={'#c6c6c6'} />
                              ) : item.device == 'MacIntel' ? (
                                <RiMacbookLine size={20} color={'#c6c6c6'} />
                              ) : (
                                <FaLinux size={20} color={'#333'} />
                              )}
                              &nbsp; {item.device == 'MacIntel' ? 'Mac' : item.device}{' '}
                              <label className="counts">{item.platformCount}</label>
                            </label>
                            <label
                              style={{
                                color: 'grey',
                                fontSize: 13,
                                fontWeight: 400,
                                textTransform: 'none',
                                cursor: 'pointer',
                              }}
                            ></label>
                          </label>
                        </div>

                        <div className="col-6" style={{ cursor: 'pointer' }}>
                          <label
                            className="item-names w-100 small-details p-0"
                            style={{
                              color: '#000',
                              cursor: 'pointer',
                              marginBottom: 0,
                            }}
                          >
                            <label style={{ fontWeight: 400, marginBottom: 0 }}>
                              {item.useragent == 'Edge' ? (
                                <FaEdge size={20} color={'#069'} />
                              ) : item.useragent == 'Chrome' ? (
                                <IoLogoChrome size={20} color={'red'} />
                              ) : item.useragent == 'Firefox' ? (
                                <FaFirefox size={20} color={'#ffa500'} />
                              ) : item.useragent == 'Safari' ? (
                                <FaSafari size={20} color={'#3399cc'} />
                              ) : (
                                <FaLinux size={20} color={'#333'} />
                              )}
                              &nbsp; {item.useragent}
                            </label>
                            <label
                              style={{
                                color: 'grey',
                                fontSize: 13,
                                fontWeight: 'normal',
                                textTransform: 'none',
                                cursor: 'pointer',
                              }}
                            ></label>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </div>
    )
  }

  const customerlistF = () => {
    let activeString = ''
    const accountid = localStorage.getItem('businessid')
    const businessname = localStorage.getItem('businessname')
    const accounttype = localStorage.getItem('accounttype')

    return (
      <div>
        {customerlist.length < 1 ? (
          <div>
            <label
              style={{
                width: '100%',
                textAlign: 'center',
                fontSize: 13.5,
                color: '#5B7083',
              }}
            >
              No one bought tickets under <br />
              this campaign as yet{' '}
            </label>
          </div>
        ) : (
          customerlist.map((item, index) => {
            return (
              <div className={'col-lg-12 p-0'}>
                <div className="item-select w-100 pr-0 pl-0 pb-0 pt-2">
                  <Link
                    to={{
                      pathname: '/customerprofile',
                      state: {
                        accountid: localStorage.getItem('businessid'),
                        accounttype: accounttype,
                        clientid: item.clientid,
                        phone: item.phone,
                        clientename: item.fname + ' ' + item.lname,
                        email: item.email,
                        prevpage: 'customers',
                      },
                    }}
                    className="w-100"
                  >
                    <div className="row" style={{ display: 'flex' }}>
                      <div className="col-12" style={{ cursor: 'pointer' }}>
                        <label
                          className="item-names w-100 small-details p-0 "
                          style={{
                            color: '#000',
                            cursor: 'pointer',
                          }}
                        >
                          <label className="mb-0">
                            {item.fname} {item.lname}
                          </label>
                          <label
                            style={{
                              color: 'grey',
                              fontSize: 13,
                              fontWeight: 'normal',
                              textTransform: 'none',
                              cursor: 'pointer',
                            }}
                          ></label>
                        </label>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            )
          })
        )}
      </div>
    )
  }

  const eventsF = () => {
    let activeString = ''
    const accountid = localStorage.getItem('businessid')
    const businessname = localStorage.getItem('businessname')
    const accounttype = localStorage.getItem('accounttype')
    let { event, poster, nb } = ''

    let currentDate = new Date()
    let month = ''
    let date = ''
    if (currentDate.getMonth() <= 9) {
      month = '0' + (currentDate.getMonth() + 1)
    } else {
      month = currentDate.getMonth() + 1
    }

    if (currentDate.getDate() <= 9) {
      date = '0' + currentDate.getDate()
    } else {
      date = currentDate.getDate()
    }

    let curDate = currentDate.getFullYear() + '-' + month + '-' + date

    let string = ''

    return (
      <div>
        {events.length < 1 ? (
          <div>
            <label
              style={{
                width: '100%',
                textAlign: 'center',
                fontSize: 13.5,
                color: '#5B7083',
              }}
            >
              You have no events{' '}
            </label>
          </div>
        ) : (
          events.map((item, index) => {
            let tempEventname = item.eventname
            const passEventname = tempEventname
            const campaignstatus = item.campaignstatus
            let budget = item.budget
            let ticketset = item.ticketid
            let markticketset = ''
            let inCheckmark = ''
            let thumbnail = item.thumbnail
            let pausebtn = ''
            {
              item.activation == 1
                ? (activeString = <IoIosCheckmarkCircleOutline size={18} color="green" />)
                : (activeString = <IoIosRemoveCircleOutline size={18} color="red" />)
            }

            event = item.eventname

            if (item.thumbnail.trim() === '' || item.thumbnail.trim() === 'none') {
              poster = `${API_URL}/apps/kscanner/placeholder.png`
              nb = (
                <label
                  className="float-right"
                  style={{
                    color: 'red',
                    float: 'right',
                    fontWeight: 400,
                  }}
                >
                  <i>Complete event setup!</i>
                </label>
              )
            } else {
              nb = ''
              poster = `${API_URL}/apps/kscanner/posters/${item.businessid}/${item.eventid}/${item.thumbnail}`
            }

            return (
              <div className={'col-lg-12 p-0'}>
                <label className="w-100 p-0 mb-2">
                  {item.event_day < curDate ? (
                    <div className="w-100">
                      <label style={{ fontSize: 14 }}>
                        {event}
                        <br />
                        <label className="text-12 text-grey">{item.event_day}</label>
                      </label>
                    </div>
                  ) : (
                    <Link
                      to={{
                        pathname: '/campaign',
                        state: {
                          eventid: item.eventid,
                          eventname: item.eventname,
                          poster: poster,
                          eventdate: item.eventday,
                          enddate: item.enddate,
                          event_date: item.event_day,
                          finish_date: item.finish_day,
                          theme: item.theme,
                          venue: item.venue,
                          expectednum: item.expected,
                          time: item.time,
                          endtime: item.endtime,
                          prevpage: 'campaigns',
                          currentpage: 'campaigns',
                        },
                      }}
                      className="w-100"
                      style={{ fontSize: 14 }}
                    >
                      {event} {nb}
                      <br />
                      <label className="text-12 text-grey">{item.event_day}</label>
                    </Link>
                  )}
                </label>
              </div>
            )
          })
        )}
      </div>
    )
  }

  const refresh = () => {
    setLoadBarProgress(true)
    setRefreshingText(true)
    setCountU(countU + 1)
    // setTimeout(() => {
    //   setLoadBarProgress(false);
    // setRefreshingText(false);
    // }, 3000);

    // history.push("/campaigns");
  }

  const newCampaign = () => {
    setLoadCustomers(false)
    setCustomers('new-campaign-button')
    setPlatforms('new-campaign-button')
    setLoadingPlatforms(false)

    if (loadingEvents == true) {
      setLoadingEvents(false)
      setNewcampaignbutton('new-campaign-button')
    } else {
      setLoadingEvents(true)
      setNewcampaignbutton('new-campaign-button-active')
    }
  }

  const PlatformsF = () => {
    const businessid = localStorage.getItem('businessid')

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=PLATFORMS&businessid=${businessid}&eventid=${eventid}`,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        setCountU(countU + 1)
        if (response.data.val == 0) {
          setPlatformlist([])
        } else {
          setPlatformlist(response.data)
        }
      })
      .catch((error) => console.log(error))

    if (count == 1) {
      setNewcampaignbutton('new-campaign-button')
      setCustomers('new-campaign-button')
      setLoadCustomers(false)
      setLoadingEvents(false)
      if (loadingPlatforms == true) {
        setLoadingPlatforms(false)
        setPlatforms('new-campaign-button')
      } else {
        setLoadingPlatforms(true)
        setPlatforms('new-campaign-button-active')
      }
    }
  }

  const CustomersF = () => {
    const businessid = localStorage.getItem('businessid')
    const accounttype = localStorage.getItem('accounttype')
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=CLIENTELE&subquery=GETCLIENTELE&&eventid=${eventid}&businessid=${businessid}`,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        if (response.data.val == 0) {
          setCustomerlist([])
        } else {
          setCustomerlist(response.data)
        }
      })
      .catch((error) => console.log(error))

    if (count == 1) {
      setLoadingEvents(false)
      setNewcampaignbutton('new-campaign-button')
      setPlatforms('new-campaign-button')
      setLoadingPlatforms(false)

      if (loadCustomers == true) {
        setLoadCustomers(false)
        setCustomers('new-campaign-button')
      } else {
        setLoadCustomers(true)
        setCustomers('new-campaign-button-active')
      }
    }
  }

  const handleOnChange = (eventid) => {
    setLoadBarProgress(true)

    history.push('/campaigns')
    const businessid = localStorage.getItem('businessid')

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=RESUMECAMPAIGN&eventid=${eventid}&businessid=${businessid}`,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        setLoadBarProgress(false)
        setCampaignCount(response.data.campaignCount)
        setCountU(countU + 1)
      })
      .catch((error) => console.log(error))
  }

  const handleTick = (
    eventid,
    eventname,
    poster,
    eventdate,
    enddate,
    event_date,
    finish_date,
    theme,
    venue,
    expectednum,
    time,
    endtime
  ) => {
    setLoadBarProgress(true)
    setLoadingEvents(false)
    setLoadCustomers(false)
    setLoadingPlatforms(false)

    history.push('/campaigns')
    const businessid = localStorage.getItem('businessid')

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=UPDATESELECT&eventid=${eventid}&accountid=${businessid}`,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        setLoadBarProgress(false)
        setCount(response.data.counts)
        setCountU(countU + 1)
        if (response.data.val == 1) {
          setLoadCustomers(false)
          setCustomers('new-campaign-button')
          setPlatforms('new-campaign-button')
          setLoadBarProgress(true)

          setEventid(eventid)
          setEventname(eventname)
          setPoster(poster)
          setEventdate(eventdate)
          setEnddate(enddate)
          setEvent_date(event_date)
          setFinish_date(finish_date)
          setTheme(theme)
          setVenue(venue)
          setExpectednum(expectednum)
          setTime(time)
          setEndtime(endtime)

          setLoadCustomers(false)
          setCustomers('new-campaign-button')
          setPlatforms('new-campaign-button')
          setLoadBarProgress(true)
          setEventid(eventid)
          setEventname(eventname)
          setPoster(poster)
          setEventdate(eventdate)
          setEnddate(enddate)
          setEvent_date(event_date)
          setFinish_date(finish_date)
          setTheme(theme)
          setVenue(venue)
          setExpectednum(expectednum)
          setTime(time)
          setEndtime(endtime)
        }
      })
      .catch((error) => console.log(error))
  }

  const handleSelectAll = () => {
    const businessid = localStorage.getItem('businessid')
    setLoadBarProgress(true)
    setLoadCustomers(false)

    history.push('/campaigns')

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=UPDATESELECT&businessid=${businessid}`,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        setLoadBarProgress(false)
        setCount(response.data.counts)
        if (response.data.val == 0) {
          setLoadIndi(false)
          setLoadIndiBlank(true)
          setAllselected(0)
        } else {
          setLoadIndi(true)
          setLoadIndiBlank(false)
          setAllselected(1)
        }
        setCountU(countU + 1)
      })
      .catch((error) => console.log(error))
  }

  const detailsF = () => {
    let activeString = ''
    const accountid = localStorage.getItem('businessid')
    const businessname = localStorage.getItem('businessname')
    const accounttype = localStorage.getItem('accounttype')
    let { event, poster, nb } = ''

    let currentDate = new Date()
    let month = ''
    let date = ''
    if (currentDate.getMonth() <= 9) {
      month = '0' + (currentDate.getMonth() + 1)
    } else {
      month = currentDate.getMonth() + 1
    }

    if (currentDate.getDate() <= 9) {
      date = '0' + currentDate.getDate()
    } else {
      date = currentDate.getDate()
    }

    let curDate = currentDate.getFullYear() + '-' + month + '-' + date

    let { string, campaignname, boolean, remainingBalance, campaignid } = ''

    const style = open ? { display: 'none' } : {}
    const logoStyle = openLogo ? { display: 'none' } : {}
    const arrowIconStyle = arrowIcon ? { display: 'none' } : {}

    const year = currentDate.getFullYear()
    const fulldate = year + '-' + month + '-' + date

    const parseCurrency = (value) => {
      const cleaned = (value || '0').replace(/,/g, '')
      const parsed = parseFloat(cleaned)
      return isNaN(parsed) ? 0 : parsed
    }

    return (
      <div className="vertical-scroll">
        <table width="100%" className="table table-striped table-bordered">
          <tr>
            <td width={'5%'} className="text-center">
              <span>On/Off</span>
            </td>
            <td width={'5%'} className="text-center">
              {' '}
              <label style={{ cursor: 'pointer' }} onClick={() => handleSelectAll()}>
                {allselected == 0 ? (
                  <RiCheckboxBlankLine size={30} color={'#000'} />
                ) : (
                  <RiCheckboxLine size={30} color={'#66b266'} />
                )}
              </label>
            </td>
            <td width={'5%'} className="text-center">
              <span></span>
            </td>
            <td width={'10%'}>
              <label data-tip="Name of the campaign" data-effect="solid" className="">
                <span>Campaign</span>
                <ReactTooltip />
              </label>
            </td>
            <td width={'10%'}>
              <label data-tip="Event associated with this campaign" data-effect="solid">
                <span>Event</span>
                <ReactTooltip />
              </label>
            </td>

            <td width={'7%'}>
              <label data-tip="Shows whether or not this running" data-effect="solid">
                <span>Status</span>
                <ReactTooltip />
              </label>
            </td>

            <td width={'10%'}>
              <label data-tip="The duration in which this campaign is running" data-effect="solid">
                <span>Running period</span>
                <ReactTooltip />
              </label>
            </td>

            <td width={'10%'}>
              <label
                data-tip="The number of days remaining before this campaign ends"
                data-effect="solid"
              >
                <span>Days remaining</span>
                <ReactTooltip />
              </label>
            </td>

            <td width={'10%'}>
              <label
                data-tip="Keywords used to promote this campaign (useful for search)"
                data-effect="solid"
              >
                <span>Keywords</span>
                <ReactTooltip />
              </label>
            </td>

            {/* <td width={'7%'}>
              <label
                data-tip="Bid margins are the difference between your current budget and the estimated budget for the campaign. This helps you understand how much more you can spend to optimize your campaign."
                data-effect="solid"
              >
                <span>Bid margins</span>
                <ReactTooltip />
              </label>
            </td> */}
            {/* <td width={'7%'}>
              <label
                data-tip="Budget is the total amount you paid upfront to sell tickets for this event. It is the initial investment made to promote the campaign."
                data-effect="solid"
              >
                <span>Budget</span>
                <ReactTooltip />
              </label>
            </td> */}
            <td width={'9%'}>
              <label
                data-tip="This amount reflects the 3.5% commission accumulated from ticket sales. It will be deducted before payout."
                data-effect="solid"
              >
                <span>Platform Fee</span>
                <ReactTooltip />
              </label>
            </td>
            {/* <td width={'7%'}>
              <label
                data-tip="Balance is the remaining amount from your budget after expenditure. It reflects how much of your budget is still available for further campaign activities."
                data-effect="solid"
              >
                <span>Balance</span>
                <ReactTooltip />
              </label>
            </td> */}
            <td width={'7%'}>
              <label
                data-tip="Estimated revenue is the projected income from ticket sales for this campaign. It is based on current sales trends and expected future sales."
                data-effect="solid"
              >
                <span>Estd revenue</span>
                <ReactTooltip />
              </label>
            </td>
            <td width={'7%'}>
              <label
                data-tip="Ongoing revenue is the actual income generated from ticket sales so far. It reflects the real-time financial performance of the campaign."
                data-effect="solid"
              >
                <span>Ongoing revenue</span>
                <ReactTooltip />
              </label>
            </td>
            <td width={'7%'}>
              <label
                data-tip="Online revenue is the income generated from online ticket sales."
                data-effect="solid"
              >
                <span>Online revenue</span>
                <ReactTooltip />
              </label>
            </td>
            <td width={'7%'}>
              <label
                data-tip="Physical revenue is the income generated from physical ticket sales, such as at the event venue or through offline channels."
                data-effect="solid"
              >
                <span>Physical revenue</span>
                <ReactTooltip />
              </label>
            </td>
            <td width={'8%'}>
              <label
                data-tip="Unique buyers are the number of distinct individuals who have purchased tickets for this event. This metric helps you understand the reach of your campaign."
                data-effect="solid"
              >
                <span>Unique buyers</span>
                <ReactTooltip />
              </label>
            </td>
            <td width={'8%'}>
              <label
                data-tip="Admissions are the total number of people who are likely to attend the event based on ticket sales. This metric helps you gauge the expected turnout."
                data-effect="solid"
              >
                <span>Admissions</span>
                <ReactTooltip />
              </label>
            </td>
            <td width={'5%'}>
              <label
                data-tip="Total number of interactions, including repeat clicks by the same user."
                data-effect="solid"
              >
                <span>Clicks</span>
                <ReactTooltip />
              </label>
            </td>
            <td width={'5%'}>
              <label
                data-tip="Number of distinct users who clicked, counted only once per user."
                data-effect="solid"
              >
                <span>Unique clicks</span>
                <ReactTooltip />
              </label>
            </td>
            <td width={'7%'}>
              <label
                data-tip="Total number of times the event page was opened, including repeat visits by the same user."
                data-effect="solid"
              >
                <span>Views</span>
                <ReactTooltip />
              </label>
            </td>

            <td width={'7%'}>
              <label
                data-tip="Number of distinct users who viewed the event, counted once per session or login."
                data-effect="solid"
              >
                <span>Unique visitors</span>
                <ReactTooltip />
              </label>
            </td>
            {/* 
            <td width={'9%'}>
              <label
                data-tip="Cost per sale is the cost incurred for each ticket sold through this campaign."
                data-effect="solid"
              >
                <span>Cost per sale</span>
                <ReactTooltip />
              </label>
            </td> */}

            <td width={'10%'}>
              <label
                data-tip="The date when the event will take place. This is important for planning and scheduling purposes."
                data-effect="solid"
              >
                <span>Event date</span>
                <ReactTooltip />
              </label>
            </td>

            <td width={'10%'}>
              <label
                data-tip="The date when the campaign started running. This helps you track the duration of the campaign."
                data-effect="solid"
              >
                <span>Campaign started at</span>
                <ReactTooltip />
              </label>
            </td>
            <td width={'10%'} className="hide-border">
              <label
                data-tip="The date this campaign ends. This is crucial for understanding the campaign's timeline and planning future activities."
                data-effect="solid"
              >
                <span>Campaign ends at</span>
                <ReactTooltip />
              </label>
            </td>
          </tr>

          {details.length < 1 ? (
            <tr>
              <td colSpan={25}>
                <div className="w-100 text-left">
                  <label className="text-14">
                    You have no campaigns yet. Create one to start promoting your events.
                  </label>
                  <br />
                  <label className="new-campaign" onClick={() => newCampaign()}>
                    Create new campaign
                  </label>
                </div>
              </td>
            </tr>
          ) : (
            details.map((item, index) => {
              let tempEventname = item.eventname
              const passEventname = tempEventname
              const campaignstatus = item.campaignstatus
              let budget = item.budget
              let ticketset = item.ticketid
              let markticketset = ''
              let inCheckmark = ''
              let thumbnail = item.thumbnail
              let pausebtn = ''
              remainingBalance = item.balance
              campaignid = item.campaignid

              const digital = parseCurrency(item.digitalRevenue)
              const physical = parseCurrency(item.physicalRevenue)
              const total = digital + physical

              const feesDeducted = (
                Number(item.feesDeductedPhysical) + Number(item.feesDeductedDigital)
              ).toFixed(2)

              const currentBudget = item.budget

              const amountClean = parseFloat(currentBudget.replace(/,/g, ''))
              const feeClean = parseFloat(feesDeducted.replace(/,/g, ''))

              const currentBalance = Number(amountClean) - Number(feeClean)

              const formattedCurrentBalance = currentBalance.toLocaleString('en-ZA', {
                style: 'currency',
                currency: 'ZAR',
              })
              {
                item.activation == 1
                  ? (activeString = <IoIosCheckmarkCircleOutline size={18} color="green" />)
                  : (activeString = <IoIosRemoveCircleOutline size={18} color="red" />)
              }

              {
                item.campaignname.length > 25
                  ? (campaignname = item.campaignname.substring(0, 25) + '...')
                  : (campaignname = item.campaignname)
              }

              if (item.thumbnail.trim() === '' || item.thumbnail.trim() === 'none') {
                poster = `${API_URL}/apps/kscanner/placeholder.png`
                nb = (
                  <label
                    data-tip="Complete event setup"
                    className="float-right"
                    style={{ color: 'red', float: 'right', fontWeight: 400 }}
                  >
                    <ReactTooltip />
                    <BiEditAlt />
                  </label>
                )
              } else {
                nb = ''
                poster = `${API_URL}/apps/kscanner/posters/${item.businessid}/${item.eventid}/${item.thumbnail}`
              }

              if (item.campaignstatus == 'running') {
                boolean = true
              } else {
                boolean = false
              }
              return (
                <tr className="">
                  <td className="text-center">
                    {' '}
                    <label className="widgets">
                      {boolean}
                      <Switch onChange={() => handleOnChange(item.eventid)} checked={boolean} />
                    </label>
                  </td>
                  <td className="text-center">
                    <label
                      className=""
                      onClick={() =>
                        handleTick(
                          item.eventid,
                          item.eventname,
                          item.poster,
                          item.eventday,
                          item.enddate,
                          item.event_day,
                          item.finish_day,
                          item.theme,
                          item.venue,
                          item.expected,
                          item.time,
                          item.endtime
                        )
                      }
                    >
                      {item.selected == 0 ? (
                        <RiCheckboxBlankLine size={30} color={'#000'} />
                      ) : (
                        <RiCheckboxLine size={30} color={'#66b266'} />
                      )}
                    </label>
                  </td>
                  <td className="text-center">
                    <label
                      style={{
                        backgroundImage: `url(` + poster + `)`,
                        width: 49,
                        height: 49,
                        borderRadius: 100,
                        backgroundSize: '100%',
                      }}
                    ></label>
                  </td>
                  <td>{campaignname}</td>

                  <td>
                    <label className="w-100">{item.eventname}</label>
                  </td>
                  <td>
                    {item.campaignstatus == 'running' ? (
                      <label style={{ color: '#4ca64c' }}>Running</label>
                    ) : (
                      <>
                        {item.daysRemaining == '---' ? (
                          <label style={{ color: 'red' }}>Ended</label>
                        ) : (
                          <label style={{ color: 'silver' }}>Paused/Not started</label>
                        )}
                      </>
                    )}
                  </td>

                  <td>{item.getPeriod} days</td>
                  <td>
                    {item.daysRemaining}{' '}
                    {item.daysRemaining == '---' ? '' : item.daysRemaining == 1 ? 'day' : 'days'}
                  </td>
                  <td>{item.keywords}</td>
                  {/* <td>
                    {item.budget < 350 ? (
                      <label style={{ color: 'silver' }}>Lowest</label>
                    ) : item.budget <= 450 ? (
                      <label style={{ color: 'silver' }}>Average</label>
                    ) : item.budget <= 999 ? (
                      <label style={{ color: '#4ca64c' }}>High</label>
                    ) : (
                      <label style={{ color: '#4ca64c' }}>Higher</label>
                    )}
                  </td> */}
                  {/* <td> R{currentBudget}</td> */}
                  <td> R{feesDeducted}</td>
                  {/* <td className="cell-relative">
                    {formattedCurrentBalance || 'R' + currentBudget}
                    <sup>
                      {item.transferred == 1 ? (
                        <label className="fontsize-12 color-red">(Transferred)</label>
                      ) : (
                        ''
                      )}
                    </sup>
                    <br />
                    {parseFloat(currentBalance || currentBudget) > 0 &&
                    parseFloat(item.transferred.replace(/,/g, '')) == 0 ? (
                      <div>
                        <label
                          className="color-blue fontsize-12"
                          onClick={() =>
                            handleYesTransfer(item.campaignid, currentBalance || currentBudget)
                          }
                        >
                          Transfer balance
                          {item.markedtransfer == 0 ? (
                            <IoIosArrowDown size={15} />
                          ) : (
                            <IoIosArrowUp size={15} />
                          )}
                        </label>{' '}
                        <br />
                        {item.markedtransfer == 1 ? (
                          <label>
                            <input
                              className={'search-new-event'}
                              autoFocus={true}
                              placeholder="Search event"
                              value={searchValue}
                              onChange={(event) => handleSearch(event, item.campaignid)}
                              autoComplete={'off'}
                            />
                            {loadSearchresults && (
                              <label className="sub-results-tranfer">
                                {queryResults.length < 1 ? (
                                  <div className="no-match-found text-center pl-3 pr-3">
                                    <span className="small-details font-size">
                                      Either you have no upcoming events <br />
                                      or there was no match for your <br />
                                      search
                                    </span>
                                  </div>
                                ) : (
                                  <div>
                                    <label className="w-100">
                                      <label className="pl-2 pr-2pt-2">
                                        <span className="fontsize-12">Click event to transfer</span>
                                      </label>
                                      <div className="h-divider w-100 mt-0 mb-0" />
                                    </label>
                                    {queryResults.map((list, index) => {
                                      const posterUri = `${API_URL}/apps/kscanner/posters/${list.businessid}/${list.eventid}/${list.poster}`
                                      if (list.indexid >= 1) {
                                        return ''
                                      } else {
                                        return (
                                          <div className="row">
                                            <div className="col-12 pl-0 pr-0" key={index}>
                                              <div className="row">
                                                <div
                                                  onClick={() =>
                                                    handleTransfer(
                                                      currentBalance || currentBudget,
                                                      item.campaignid,
                                                      list.eventid,
                                                      item.feesDeductedPhysical
                                                    )
                                                  }
                                                  className="eventLinks links-width"
                                                >
                                                  <div className="search-results-inner">
                                                 
                                                    <div className="results-container align-self-center text-left">
                                                      <BsSearch />
                                                      &nbsp; {list.event_name}
                                                      
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      }
                                    })}
                                  </div>
                                )}
                              </label>
                            )}
                          </label>
                        ) : (
                          ''
                        )}
                      </div>
                    ) : (
                      <label
                        className="small-details fontsize-12"
                        onClick={() =>
                          handleNotTransfer(item.transferred, currentBalance || currentBudget)
                        }
                      >
                        Transfer balance
                      </label>
                    )}
                  </td> */}
                  <td>R{item.estdRevenue}</td>
                  <td>
                    R
                    {total.toLocaleString('en-ZA', {
                      minimumFractionDigits: 2,
                    })}
                  </td>
                  <td> R{item.digitalRevenue ?? 0.0}</td>
                  <td> R{item.physicalRevenue ?? 0.0}</td>
                  <td> {item.buyers ?? 0}</td>

                  <td>{item.admission ?? 0}</td>
                  <td>{item.eventClicks}</td>
                  <td>{item.unique_clicks}</td>
                  <td>{item.views}</td>
                  <td>{item.unique_visitors}</td>
                  {/* <td className="">
                    <span>Digital:</span> 3.5%.
                    <br />
                    <span>Physical:</span> R1.0 per download,
                    <br />
                    R2.50 per ticket print.
                  </td> */}
                  <td>{item.eventday}</td>
                  <td>{item.fromdate}</td>
                  <td>{item.todate}</td>
                </tr>
              )
            })
          )}
        </table>
      </div>
    )
  }

  const handleScan = (data) => {
    setResult(data)
  }
  const handleError = (err) => {
    console.error(err)
  }

  const handleEdit = () => {
    if (count == 1) {
      // alert(eventid);
      history.push({
        pathname: '/campaign',
        state: {
          eventid: eventid,
          eventname: eventname,
          poster: poster,
          eventdate: eventdate,
          enddate: enddate,
          event_date: event_date,
          finish_date: finish_date,
          theme: theme,
          venue: venue,
          expectednum: expectednum,
          time: time,
          endtime: endtime,
          prevpage: 'campaigns',
          currentpage: 'campaigns',
        },
      })
    }
  }

  const handleAnalytics = () => {
    if (count == 1) {
      // alert(endtime);
      history.push({
        pathname: '/analytics',
        state: {
          eventid: eventid,
          eventname: eventname,
          poster: poster,
          eventdate: eventdate,
          enddate: enddate,
          event_date: event_date,
          finish_date: finish_date,
          theme: theme,
          venue: venue,
          expectednum: expectednum,
          time: time,
          endtime: endtime,
          prevpage: 'campaigns',
          currentpage: 'campaigns',
          back: 'campaigns',
        },
      })
    }
  }

  const handleResume = () => {
    setLoadBarProgress(true)
    const businessid = localStorage.getItem('businessid')
    if (count > 1) {
      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=RESUMECAMPAIGNS&businessid=${businessid}`,
        {
          withCredentials: true,
        }
      )
        .then((response) => {
          setCountU(countU + 1)
          setLoadBarProgress(false)
        })
        .catch((error) => console.log(error))

      history.push('/campaigns')
    }
  }

  const handleYesTransfer = (campaignid, balance) => {
    const businessid = localStorage.getItem('businessid')
    setSearchValue('')
    setLoadSearchresults(false)
    setBalance(balance)

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=UPDATETRANSFERCHECK&campaignid=${campaignid}&businessid=${businessid}`,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        setCountU(countU + 1)
        if (response.data.status === 'success') {
          setLoadBarProgress(true)
          setLoadSearchBox(true)
          setCampaignid(campaignid)
        } else {
          setLoadBarProgress(true)
          setLoadSearchBox(false)
        }
      })
      .catch((error) => console.log(error))
    history.push('/campaigns')
  }

  const handleTransfer = (getBalance, campaignid, neweventid, spent) => {
    const cleanBalance = getBalance.replace(/,/g, '')
    const balance = parseFloat(cleanBalance)

    if (balance <= 0) {
      setError("You can't transfer if your balance is at R0.0")
      setErrorDisplay('block')
      setTimeout(() => {
        setErrorDisplay('none')
      }, 5000)
      return
    }

    if (neweventid == 0) {
      setError('Please select an event to transfer balance to.')
      setErrorDisplay('block')
      setTimeout(() => {
        setErrorDisplay('none')
      }, 5000)
      return
    }

    // if (spent == 0) {
    //   setError("You can't transfer if your spent is at R0.0");
    //   setErrorDisplay("block");
    //   setTimeout(() => {
    //     setErrorDisplay("none");
    //   }, 5000);
    //   return;
    // }
    const data = new FormData()
    data.append('campaignid', campaignid)
    data.append('neweventid', neweventid)
    data.append('balance', balance)
    data.append('spent', spent)
    data.append('query', 'TRANSFERBALANCE')
    setLoadBarProgress(true)

    Axios({
      method: 'POST',
      url: `${API_URL}/apps/kscanner/webservices.php`,
      data: data,
      withCredentials: true,
    })
      .then((response) => {
        if (response.data.status === 'success') {
          setCountU(countU + 1)
          setLoadBarProgress(false)
          setLoadSearchBox(false)
          setCampaignid(campaignid)
          setError(response.data.message)
          setErrorDisplay('block')
          setAlertType('success-login')
          setSearchValue('')
          setLoadSearchresults(false)
        } else {
          setError(response.data.message)
          setErrorDisplay('block')
          setLoadBarProgress(false)
          setAlertType('error-login')
          console.log(response.data.message)
        }
        setTimeout(() => {
          setErrorDisplay('none')
        }, 5000)
      })
      .catch((error) => {
        console.log(error)
        setError('An error occurred while transferring balance.')
        setErrorDisplay('block')
        setLoadBarProgress(false)
        setAlertType('error-login')

        setTimeout(() => {
          setErrorDisplay('none')
        }, 5000)
      })
  }

  const handleNotTransfer = (transferredid, balance) => {
    if (transferredid == 1) {
      setError(`R${balance} has already been transferred to another campaign`)
      setErrorDisplay('block')
    } else if (balance <= 0) {
      setError("You can't transfer if your balance is at R0.0")
      setErrorDisplay('block')
    }

    setTimeout(() => {
      setErrorDisplay('none')
    }, 5000)
  }

  const closeError = () => {
    setErrorDisplay('none')
  }

  const handleSearch = async (event, campaign_id) => {
    // alert(campaignid);
    setSearchValue(event.target.value)
    const businessid = localStorage.getItem('businessid')
    const searchVal = event.target.value
    const formData = new FormData()
    formData.append('search', event.target.value)

    await Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=SEARCHEVENTS&search=${searchVal}&businessid=${businessid}&campaignid=${campaign_id}`,
      {
        withCredentials: true,
      }
    ).then((response) => {
      if (response.data.val == 0) {
        setQueryResults([])
      } else {
        setQueryResults(response.data)
      }
    })

    if (!searchVal) {
      setLoadSearchresults(false)
    } else {
      setLoadSearchresults(true)
    }
  }

  if (localStorage.getItem('businessid') === null) {
    return <Redirect to="/login" />
    //   return exit(1);
  } else {
  }
  const businessname = localStorage.getItem('businessname')
  const businessid = localStorage.getItem('businessid')
  const accounttype = localStorage.getItem('accounttype')

  const previewStyle = {
    height: 240,
    width: 320,
    border: 'thin solid red',
  }

  let activeEdit = ''

  if (count == 1) {
    activeEdit = ''
  } else {
    activeEdit = 'button-disabled'
  }

  const handleToggle = () => {
    setCollapsed((prev) => !prev)
  }

  return (
    <div className="view">
      {loadBarProgress && <TopBarProgress />}
      <Header />
      <SideNav collapsed={collapsed} onToggle={handleToggle} />
      <div
        className="main-content"
        style={{
          marginTop: 40,
          marginLeft: isMob ? '0px' : collapsed ? '60px' : '240px',
        }}
      >
        {/* ✅ Mobile overlay when sidebar is open */}
        {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}

        {isMob && collapsed && (
          <label className="mobile-toggle" onClick={handleToggle}>
            <BiMenu size={25} />
          </label>
        )}
        <div className="row justify-content-center just-container-insid">
          <div className="col-lg-12">
            <div className="col-12 mt-5 mb-2">
              <span>
                {count == 1
                  ? campaignname ?? 'No campaign selected'
                  : count == 0
                  ? 'No campaign selected'
                  : count + ' Campaigns selected'}
              </span>

              <span className="float-right cursor-pointer" onClick={() => history.goBack()}>
                <IoIosArrowBack size={25} /> Back
              </span>
            </div>
            <div className=" BoxDashboardContainer mb-4 pb-3  pl-3 pr-3">
              <div className="">
                <div className="row vertical-scroll top-data-taps">
                  <div className="col-lg-2 col-4 col-sm-3 col-md-3 mt-2">
                    <div className="item-list pl-1">
                      <label className="ticket-title  pl-0 pr-0">CAMPAIGNS</label>
                    </div>
                  </div>

                  <div className="col-lg-10 col-8 col-sm-9 col-md-9 text-right  pl-0 pr-0">
                    {refreshingText && <label className="refreshing-text">Refreshing...</label>}
                    &nbsp; &nbsp;
                    <label className="refresh-icon" data-tip="Refresh" onClick={() => refresh()}>
                      <IoIosRefresh size={20} />
                      <ReactTooltip />
                    </label>
                    {count == 0 ? (
                      ''
                    ) : (
                      <label className="new-campaign-button button-select">{count} Selected</label>
                    )}
                    {allselected >= 1 ? (
                      <label
                        className={
                          count == 1 ? 'new-campaign-button button-disabled' : 'new-campaign-button'
                        }
                        onClick={() => handleResume()}
                      >
                        <BsArrowRight /> Resume/Pause all campaigns
                      </label>
                    ) : (
                      ''
                    )}
                    <label className={platforms + ' ' + activeEdit} onClick={() => PlatformsF()}>
                      Devices
                    </label>
                    <label
                      className={'new-campaign-button ' + activeEdit}
                      onClick={() => handleAnalytics()}
                    >
                      <BsGraphUp /> Analytics
                    </label>
                    <label className={customers + ' ' + activeEdit} onClick={() => CustomersF()}>
                      <BsPeople /> Unique buyers
                    </label>
                    <label
                      className={'new-campaign-button ' + activeEdit}
                      onClick={() => handleEdit()}
                    >
                      <BsPen /> Edit
                    </label>
                    <label className={newcampaignbutton} onClick={() => newCampaign()}>
                      <IoIosAddCircleOutline /> Create campaign
                    </label>
                  </div>

                  {/* <div className="h-divider w-100" /> */}
                </div>
                {loadingPlatforms && (
                  <div className="listplatforms BoxDashboardContainer text-left pl-0 pr-0">
                    <label className="pl-3 pr-3 w-100 mb-0">
                      <strong>Devices used to access this event</strong>
                      <br />
                      <label className="small-details">
                        <span>Event:</span> {campaignname}
                      </label>
                      <label className="float-right">
                        <Link
                          to={{
                            pathname: 'addevent',
                            state: { prevpage: 'dashboard' },
                          }}
                        ></Link>
                      </label>
                    </label>

                    <div className="h-divider w-100" />
                    <div className="listcustomers-header pl-3 pr-3 pb-2">{platformlistF()}</div>
                  </div>
                )}

                {loadingEvents && (
                  <div className="select-event BoxDashboardContainer text-left pl-0 pr-0">
                    <label className="pl-3 pr-3 w-100 mb-0">
                      <strong>Select event</strong>
                      <label className="float-right">
                        <Link
                          to={{
                            pathname: 'addevent',
                            state: { prevpage: 'dashboard' },
                          }}
                          className="float-right color-blue"
                        >
                          Create event
                        </Link>
                      </label>
                    </label>

                    <div className="h-divider w-100 mt-0" />
                    <div className="listcustomers-header pl-3 pr-3 pb-2">{eventsF()}</div>
                  </div>
                )}
                {loadCustomers && (
                  <div className="listcustomers BoxDashboardContainer text-left pl-0 pr-0">
                    <label className="pl-3 pr-3">
                      <span>{campaignname}</span>
                    </label>

                    <div className="h-divider w-100" />
                    <div className="listcustomers-header pl-3 pr-3 pb-2">{customerlistF()}</div>
                  </div>
                )}
              </div>
              {detailsF()}
            </div>
          </div>
        </div>
      </div>

      <div
        className={alertType}
        style={{ display: errorDisplay, textAlign: 'center' }}
        onClick={() => closeError()}
      >
        {error}
      </div>
      {/* <Footer /> */}
    </div>
  )
}

export default Campaignmanager
